import {
  Configuration,
  BaseUserApi,
  FeedbackApi,
  TestApi,
  CarouselApi,
  EducationstageApi,
  GradeApi,
  CategoryApi,
  CosApi,
  CouponpackageApi,
  CouponApi,
  CouponcodeApi,
  BillApi,
  FileApi,
} from '@/api';
import { axios } from 'hpsfir-managebase-ui';

interface BaseApi {
  baseUrl: string;
  uploadFileUrl: string;
  baseUserApi: BaseUserApi;
  feedbackApi: FeedbackApi;
  testApi: TestApi;
  carouselApi: CarouselApi;
  educationstageApi: EducationstageApi;
  gradeApi: GradeApi;
  categoryApi: CategoryApi;
  cosApi: CosApi;
  couponpackageApi: CouponpackageApi;
  couponApi: CouponApi;
  couponcodeApi: CouponcodeApi;
  billApi: BillApi;
  fileApi: FileApi;
}

const api: BaseApi = {

} as any;

export const initApi = (basePath: string) => {
  const apiConfig = new Configuration({
    basePath,
  });
  api.baseUrl = basePath;
  api.uploadFileUrl = '/upload/file';
  api.baseUserApi = new BaseUserApi(apiConfig, basePath, axios);
  api.feedbackApi = new FeedbackApi(apiConfig, basePath, axios);
  api.testApi = new TestApi(apiConfig, basePath, axios);
  api.carouselApi = new CarouselApi(apiConfig, basePath, axios);
  api.educationstageApi = new EducationstageApi(apiConfig, basePath, axios);
  api.gradeApi = new GradeApi(apiConfig, basePath, axios);
  api.categoryApi = new CategoryApi(apiConfig, basePath, axios);
  api.cosApi = new CosApi(apiConfig, basePath, axios);
  api.couponpackageApi = new CouponpackageApi(apiConfig, basePath, axios);
  api.couponApi = new CouponApi(apiConfig, basePath, axios);
  api.couponcodeApi = new CouponcodeApi(apiConfig, basePath, axios);
  api.billApi = new BillApi(apiConfig, basePath, axios);
  api.fileApi = new FileApi(apiConfig, basePath, axios);
};

export const useApi = () => api;

